module.exports = __webpack_public_path__ + "img/logo.b4b2cc8e.png";